import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=f61465a0"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=f61465a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports